var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.709823,0,0,0.642333,12.3462,16.303)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-6.68242,1.77636e-14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.56818,-8.86478e-16,1.0035e-14,-11.9558,-14.0842,764.559)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.979,
    y: 56.875,
    width: 19.009,
    height: 1.22
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8.79734e-17,-1.42819,4.05259,2.49691e-16,-36.2185,107.956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.375,19.905L16.375,16.59L51.285,16.59L51.285,14.08L64.354,18.247L51.285,22.415L51.285,19.905L16.375,19.905Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,1.22465e-16,-1.22465e-16,-1,112.776,104.921)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.56818,-8.86478e-16,1.0035e-14,-11.9558,-14.0842,764.559)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.979,
    y: 56.875,
    width: 19.009,
    height: 1.22
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8.79734e-17,-1.42819,4.05259,2.49691e-16,-36.2185,107.956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.375,19.905L16.375,16.59L51.285,16.59L51.285,14.08L64.354,18.247L51.285,22.415L51.285,19.905L16.375,19.905Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.c177e5f395b7f1f8bacf551823c9cb8b.svg";
export { ForwardRef as ReactComponent };